<template>
  <div>
    <ul class="select-option" style="overflow: hidden; margin-bottom: 0px">
      <li>
        <span class="select-title">受助人姓名：</span>
        <el-input
          v-model="recName"
          placeholder="请输入受助人姓名"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>
      <li>
        <span class="select-title">受助人身份证号：</span>
        <el-input
          v-model="recIdno"
          maxlength="18"
          placeholder="请输入受助人身份证号"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>
      <li>
        <span class="select-title">事件ID：</span>
        <el-input
          v-model="caseId"
          placeholder="请输入事件ID"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>
      <li>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      </li>
    </ul>
    <div>
      <el-radio-group
        v-model="searchType"
        style="margin-right: 30px"
        @change="typechange"
      >
        <el-radio-button label="1">初审新案</el-radio-button>
        <el-radio-button label="2">初审补件</el-radio-button>
        <el-radio-button label="3">复审新案</el-radio-button>
        <el-radio-button label="4">交叉审新案</el-radio-button>
        <el-radio-button label="5">复审补件/退调查/补充调查</el-radio-button>
      </el-radio-group>
      <el-button
        v-if="checkPermission('变更处理账号', permList)"
        type="primary"
        icon="iconfont icon-biangeng"
        @click="changecase"
      >
        变更处理账号
      </el-button>
    </div>

    <el-table
      ref="multipleTable"
      :data="tableData.records"
      border
      tooltip-effect="dark"
      style="width: 100%; margin-top: 15px"
      :row-style="rowStyle"
      :row-class-name="rowClassName"
      @selection-change="selectionChange"
      @row-click="rowClick"
    >
      <el-table-column
        label="序号"
        type="index"
        :index="indexMethod"
        width="50"
        align="center"
      />

      <el-table-column type="selection" width="60" align="center" />
      <el-table-column label="事件id" prop="caseId" />
      <el-table-column width="180" prop="reportDateString" label="报案日期" />
      <el-table-column prop="paymentDateString" label="缴费日期" show-overflow-tooltip />
      <el-table-column prop="waitDay" label="等待时长(天)" show-overflow-tooltip />
      <el-table-column prop="memberLabelName" label="会员标签" show-overflow-tooltip />
      <el-table-column prop="recName" label="受助人姓名" show-overflow-tooltip />
      <el-table-column prop="productName" label="计划名称" show-overflow-tooltip />
      <el-table-column prop="flowCodeString" label="当前流程" show-overflow-tooltip />
      <el-table-column prop="firstTrailUser" label="初审人" show-overflow-tooltip />
      <el-table-column prop="reviewUser" label="复审人" show-overflow-tooltip />
      <el-table-column prop="crossUser" label="交叉审人" show-overflow-tooltip />
    </el-table>
    <div style="text-align: center; margin-top: 25px">
      <el-pagination
        :page-size="tableData.size"
        :current-page="pageIndex"
        background
        layout="total,prev, pager, next, jumper"
        :total="tableData.total"
        @current-change="pageChange"
      />
    </div>

    <el-dialog
      title="变更经办人"
      :visible.sync="dialogFormVisible"
      width="30%"
      custom-class="c-p"
    >
      <el-tree
        :data="dialogData"
        :props="defaultProps"
        accordion
        @node-click="changeOperator"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {

  data() {
    return {
      loading: false,
      caseId: '',
      recName: '',
      recIdno: '',
      searchType: '',
      limit: 10,
      pageIndex: 1,

      // riskCode: '',
      createTime: '',
      operatorTime: '',
      applicantName: '',
      recRealName: '',

      processOptions: [],
      optionProps: {
        expandTrigger: 'hover',
        emitPath: false,
        multiple: true,
        value: 'flowCode',
        label: 'name',
        children: 'children'
      },
      tableData: {},
      selectRows: [],
      dialogData: [],
      dialogFormVisible: false,
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      currentCode: '',
      formLabelWidth: '120px'
    }
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList
    }),

    selectRowsId() {
      const idArr = []
      if (this.selectRows.length > 0) {
        this.selectRows.filter((item) => {
          idArr.push(item.userId)
        })
      }
      return idArr
    }
  },

  created() {
    this.$emit('setCurrentMenu', '待办案件')
    this.getprocess()
  },

  methods: {
    getprocess() {
      const vm = this
      vm.axios
        .get(vm.homePath() + '/case/flow/select')
        .then((res) => {
          if (res.data.status === '000000') {
            const data = res.data.flowList
            vm.processOptions = vm.filterNull(
              vm.toTreeData(data, 'parentCode', 'flowCode')
            )
          } else {
            vm.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    filterNull(data) {
      const vm = this
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          data[i].children = undefined
        } else {
          vm.filterNull(data[i].children)
        }
      }
      return data
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.limit + index + 1
    },

    typechange(val) {
      this.searchType = val
      this.loading = true
      this.getallcase(
        this.limit,
        this.pageIndex,
        this.recName,
        this.recIdno,
        this.caseId,
        this.searchType
      )
    },

    /**
     * 等待分配时间-查询列表
     */
    getallcase(limit, page, recName, recIdno, caseId, searchType) {
      const vm = this
      vm.axios
        .get(vm.homePath() + '/case/flow/waiting/search/waiting-time', {
          params: {
            limit: limit,
            page: page,
            recName: recName,
            recIdno: recIdno,
            caseId: caseId,
            searchType: searchType
          }
        })
        .then((response) => {
          const data = response.data
          if (data.status === '000000') {
            vm.loading = false
            vm.tableData = data.page
          } else {
            vm.$alert(data.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    search() {
      this.pageIndex = 1
      this.getallcase(
        this.limit,
        this.pageIndex,
        this.recName,
        this.recIdno,
        this.caseId,
        this.searchType
      )
    },

    changecase() {
      const vm = this
      if (vm.selectRows.length < 1) {
        vm.$alert('请选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      if (vm.selectRows.length > 1) {
        vm.$alert('只能选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      vm.axios
        .get(
          vm.homePath() + '/dispatch-case/queryCaseOperators/' + vm.selectRows[0].caseCode
        )
        .then((response) => {
          const data = response.data
          if (data.status === '000000') {
            vm.dialogData = vm.filterNull(vm.toTreeData(data.data, 'parentCode', 'code'))
            vm.dialogFormVisible = true
          } else {
            vm.$alert(data.message)
          }
        })
        .catch((error) => console.log(error))
    },

    rowClick(row, column, event) {
      const refsElTable = this.$refs.multipleTable
      const findRow = this.selectRows.find((c) => c.rowIndex == row.rowIndex)
      if (findRow) {
        refsElTable.toggleRowSelection(row, false)
        return
      }
      refsElTable.clearSelection()
      refsElTable.toggleRowSelection(row)
    },

    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, 'rowIndex', {
        value: rowIndex,
        writable: true,
        enumerable: false
      })
    },

    rowClassName({ row, rowIndex }) {
      let rowName = ''
      const findRow = this.selectRows.find((c) => c.rowIndex === row.rowIndex)
      if (findRow) {
        rowName = 'current-row '
      }
      return rowName
    },

    selectionChange(rows) {
      this.selectRows = rows
    },

    changeOperator(val) {
      this.currentCode = val.code
    },

    processChange(val) {
      this.flowCode = val.join(',')
    },

    // riskChange(val) {
    //   this.riskCode = val
    // },

    handleChange(value) {
      this.selectRows = value
    },

    pageChange(val) {
      this.pageIndex = val
      this.getallcase(
        this.limit,
        this.pageIndex,
        this.recName,
        this.recIdno,
        this.caseId,
        this.searchType
      )
    },

    /**
     * 事件管理-变更处理账号
     */
    save() {
      const vm = this
      vm.axios
        .put(
          vm.homePath() +
            '/dispatch-case/updateTaskOperator/' +
            vm.selectRows[0].caseCode +
            '/' +
            vm.currentCode
        )
        .then((response) => {
          const data = response.data
          if (data.status === '000000') {
            vm.dialogFormVisible = false
            vm.$alert('更改成功', '提示', {
              callback: (action) => {
                vm.getallcase(
                  vm.limit,
                  vm.pageIndex,
                  vm.recName,
                  vm.recIdno,
                  vm.caseId,
                  vm.searchType
                )
              }
            })
          } else {
            vm.$alert(data.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => console.log(error))
    }
  }
}
</script>

<style>
.select-title {
  font-size: 14px;
  font-weight: 700;
}
.select-option li {
  float: left;
  margin: 10px;
}
.select-input {
  width: auto;
}
.el-table td,
.el-table th {
  padding: 6px 0px;
}
.el-table th {
  color: #333;
  font-weight: bold;
  text-align: center;
}
</style>
